<template>
  <v-container  class="mx-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="px-5 pb-5" fluid>
          <v-row>
            <v-card-title>
              Аккаунт
            </v-card-title>
          </v-row>
          <v-card-text class="py-0 px-1" v-if="Object.keys(this.abonent).length != 0">
            <p class="mb-1">id: {{ abonent.id }}</p>
            <p class="mb-1">Телефон: {{ abonent.telephone }}</p>
            <p class="mb-1" v-for="doorphone in abonent.doorphones" :key="doorphone.id">
              Адрес: {{ doorphone.address }}
            </p>
            <p class="mb-1" v-if="abonent.apartment">Квартира: {{ abonent.apartment }}</p>
          </v-card-text>
          <v-card flat>
            <v-card-title>Ключи</v-card-title>
            <v-data-table
              class="table"
              :headers="headersKey"
              :items="abonent.keys"
              disable-sort
              hide-default-footer
            >
              <template v-slot:item.universal="{ item }">
                {{ universalType(item) }}
              </template>
            </v-data-table>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ResidentAccountView',
  props: ['id'],
  data () {
    return {
      items: [
        {
          text: 'Аккаунты жителей',
          disabled: false,
          href: '/resident-accounts',
        },
        {
          text: 'Аккаунт',
          disabled: true,
          href: 'breadcrumbs_link_1',
        },
      ],
      headersKey: [
        { text: 'id', value: 'id' },
        { text: 'Имя', value: 'name' },
        { text: 'Код', value: 'code' },
        { text: 'Серийный номер', value: 'serial_number' },
        { text: 'Тип ключа', value: 'universal' },
      ],
    };
  },
  created () {
    this.getAbonent(this.id);
  },
  computed: {
    ...mapGetters({
      abonent: 'Abonents/abonent',
    }),
  },
  methods: {
    ...mapActions({
      getAbonent: 'Abonents/getAbonent',
    }),
    editAbonent (id) {
      this.$router.push({ name: 'Resident-accounts-edit', params: { id: id } });
    },
    universalType (item) {
      return item.universal === 0 ? 'Неуниверсальный ключ' : 'Универсальный ключ';
    },
  },
};
</script>
